<div id="national-players" class="watermark py-5">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">
        <h2 class="title text-center mb-5">National Players</h2>

        <div class="row justify-content-center">
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" *ngFor="let player of players">
            <div class="card shadow-sm border-0 h-100 player-card">
              <div class="img-wrapper">
                <img [src]="player.image" class="card-img-top player-img" [alt]="player.name">
              </div>
              <div class="card-body text-center">
                <h5 class="card-title fw-bold text-primary mb-2">{{ player.name }}</h5>
                <p class="card-text text-muted small">National Player, {{ player.sport }}</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
